// @core/api/endpoints/project/remove_item_from_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Remove item from sprint
 * Removes the sprint assignment from a project item, returning it to the backlog.
 */
export async function RemoveItemFromSprint(
  project_id: string,
  sprint_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.delete<ItemResponse>(requestPath, requestOptions);
}
